import { useCallback } from "react"
import { createModel } from "hox"
import { useSetState } from "ahooks-v2"
import type { PoiVO } from "@/api"

interface catesAgs {
  cates: PoiVO[]
}

function useCates() {
  const [state, set] = useSetState<catesAgs>({
    cates: [],
  })
  const setCates = useCallback(
    (value: PoiVO[]) => {
      set({ cates: value })
    },
    [set],
  )
  const setAllState = useCallback(
    (value: Partial<catesAgs> | ((prevState: catesAgs) => Partial<catesAgs>)) => {
      set(value)
    },
    [set],
  )
  return {
    ...state,
    setCates,
    setAllState,
  }
}

export default createModel(useCates)
